import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { SaveImageBulevart, UpdateImageBulevart } from './bulevart.interface';

@Injectable({
    providedIn: 'root'
})
export class BulevartService {
    private token!: string;
    private basePath = environment.interop.basePath;

    private listUrl =
        this.basePath +
        environment.interop.bulevart.gallery.list;

    public listDTUrl =
        this.basePath +
        environment.interop.bulevart.gallery.listDT;

    private uploadImageUrl =
        this.basePath +
        environment.interop.bulevart.gallery.uploadImage;

    private saveImageUrl =
        this.basePath +
        environment.interop.bulevart.gallery.saveImage;

    private updateImageUrl =
        this.basePath +
        environment.interop.bulevart.gallery.updateImage;

    private deleteImageUrl =
        this.basePath +
        environment.interop.bulevart.gallery.delete;

    private changeStatusActiveUrl =
        this.basePath +
        environment.interop.bulevart.gallery.active;

    private changeStatusPublicUrl =
        this.basePath +
        environment.interop.bulevart.gallery.public;

    private moveUpUrl =
        this.basePath +
        environment.interop.bulevart.gallery.moveUp;

    private moveDownUrl =
        this.basePath +
        environment.interop.bulevart.gallery.moveDown;

    private httpOptions: any;

    constructor(private http: HttpClient) { }

    getListDT() {
        return this.http.get(this.listDTUrl, this.httpOptions);
    }

    uploadImage(formData: FormData) {
        return this.http.post(this.uploadImageUrl, formData);
    }

    saveImage(payload: SaveImageBulevart[]) {
        return this.http.post(this.saveImageUrl, payload, this.httpOptions);
    }

    updateImage(payload: UpdateImageBulevart) {
        return this.http.post(this.updateImageUrl, payload, this.httpOptions);
    }

    deleteImage(id: number) {
        return this.http.delete(this.deleteImageUrl + id, this.httpOptions);
    }

    changeStatusActive(id: number) {
        return this.http.put(this.changeStatusActiveUrl + id, {}, this.httpOptions);
    }

    changeStatusPublic(id: number) {
        return this.http.put(this.changeStatusPublicUrl + id, {}, this.httpOptions);
    }

    updatePosition(id: number, index: number) {
        if (index === 1) {
            // Position +1
            return this.http.put(this.moveUpUrl + id, {}, this.httpOptions);
        } else {
            // Position -1
            return this.http.put(this.moveDownUrl + id, {}, this.httpOptions);
        }
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
